<template>
  <div class="app-nav">
    <!-- [matrah] legacy: <v-app-bar color="#0f7b3f"> -->
    <v-app-bar color="primary" density="comfortable" flat>
      <!-- <v-app-bar-nav-icon @click="openDrawer"></v-app-bar-nav-icon> -->
      <v-container fluid>
        <v-row align="center" no-gutters>
          <v-col xs="6" sm="3" md="3" lg="3">
            <router-link class="home-link" to="/">
              <!-- [matrah] legacy:
              <div class="d-flex flex-column">
                <span style="color: #FFF;font-size: 16px;font-weight: 800;">لـجـنــة الزكاة بولاية وادي المعاول</span>
                <span style="color: #FFF;font-size: 13px;font-weight: 400;padding-left:22px;">   وزارة الأوقاف و الشؤون الدينية</span>
              </div>
              -->
              <div class="brand d-flex align-center">
                <div class="brand-logo">
                  <img :src="logo" alt="Zakat Matrah" />
                </div>
                <div class="d-flex flex-column">
                  <span class="brand-title">Zakat Matrah</span>
                  <span class="brand-subtitle">WhatsApp Dashboard</span>
                </div>
              </div>
            </router-link>
          </v-col>
          <v-col xs="2" sm="6" md="6" lg="6" class="nav">
            <router-link v-for="(link, idx) in links" class="nav-link" :class="{
              'd-none d-sm-flex': link.name != 'Conversations',
            }" :to="{ name: link.urlName }" :key="idx">
              <v-icon :icon="link.icon" />

              {{ link.name }}
            </router-link>
          </v-col>
          <v-col class="nav-icon" xs="2" sm="3" md="3" lg="3">
            <!-- [matrah] Conversations where the donor asked for a human (chat = on). -->
            <v-chip v-if="needsStaffCount > 0" class="needs-staff-chip d-none d-sm-flex" color="secondary"
              variant="flat" size="small" prepend-icon="mdi-account-alert" :to="needsStaffRoute" title="Conversations waiting for staff">
              Needs staff
              <v-badge inline color="white" text-color="secondary-darken-1" :content="needsStaffCount" class="ml-1"></v-badge>
            </v-chip>
            <v-badge class="d-none d-sm-flex" dot :color="isNotify ? 'error' : 'success'">
              <v-icon icon="mdi-bell" @click="openDrawer" />
            </v-badge>
            <router-link class="nav-icon-link d-none d-sm-flex text-decoration-none" title="Setting" to="/settings">
              <v-icon icon="mdi-cog" />
            </router-link>
            <router-link class="nav-icon-link" @click="dialog = true" color="none" title="Logout" to="#">
              <v-icon title="logout" icon="mdi-logout" v-bind="props"></v-icon>
            </router-link>

          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="dialog" persistent width="auto">

        <v-card>
          <v-card-title class="text-h5"> Logout </v-card-title>
          <v-card-text>Are you sure you want to logout?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green-darken-1" variant="text" @click="logoutHandler"> Yes </v-btn>
            <v-btn color="green-darken-1" variant="text" @click="dialog = false"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-app-bar>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { useGlobalStore } from '../../stores/global'
import { useUserStore } from '../../stores/user'
import auth from '../../api/auth'
// [matrah] toasts
import { toastSuccess, toastApiError } from '../../utils/notify'
import logo from '../../assets/matrah-logo-transparent.png'
export default {
  inject: ['Emitter'],
  data: () => ({
    appName: process.env.VUE_APP_NAME,
    logo,
    drawer: true,
    dialog: false,
    links: [
      {
        urlName: 'conversations',
        name: 'Conversations',
        icon: 'mdi-chat',
      },
      {
        urlName: 'templates',
        name: 'Templates',
        icon: 'mdi-card-text-outline',
      },
      {
        urlName: 'templatesStatistics',
        name: 'Templates Statistics',
        icon: 'mdi-chart-box-outline',
      }
    ],
    needsStaffRoute: { name: 'conversations', query: { needs_staff: '1' } },
  }),
  computed: {
    ...mapState(useGlobalStore, ['isNotify']),
    ...mapState(useUserStore, ['needsStaffCount', 'userList']),
  },
  async mounted() {
    // [matrah] The needs-staff counter is derived from the loaded user list, so make
    // sure the first page is available even when the admin lands on another page.
    // [matrah] legacy: if (!this.userList) {
    // Never call the API without a session (a 401 there used to trigger a reload loop).
    if (!this.userList && window.$cookies && window.$cookies.get('jwt')) {
      try {
        await this.getUsersWithPagination()
      } catch (error) {
        console.error('AppNav | could not preload users', error)
      }
    }
  },
  methods: {
    ...mapActions(useGlobalStore, ['resetNotify']),
    ...mapActions(useUserStore, ['getUsersWithPagination']),
    openDrawer() {
      this.Emitter.emit('openDrawer')
      this.resetNotify()
    },
    async logoutHandler() {
      try {
        await auth.logout(`auth/logout`)
        window.$cookies.remove('jwt')
        // window.location.reload();
        this.dialog = false
        await this.$router.push({ name: 'login' })
        // [matrah]
        toastSuccess('You have been logged out.')
      } catch (error) {
        console.error(error)
        // [matrah]
        toastApiError(error, 'Logout failed')
      }
    },
  },
}
</script>
<style scoped>
.home-link {
  display: block;
}

.home-img {
  width: 50%;
  /* Adjust width as needed */
  height: 65px;
  /* Maintain aspect ratio */
}

.brand {
  gap: 10px;
}

.brand-logo {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  flex: 0 0 auto;
}

.brand-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.brand-title {
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: 0.2px;
}

.brand-subtitle {
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
}

.links {
  list-style: none;
  gap: 25px;
}

.nav {
  display: flex;
  justify-content: start;
  gap: 30px;
  align-items: center;
}

.nav-icon {
  display: flex;
  justify-content: end;
  gap: 10px;
  align-items: center;

  color: #FFF;

}

.needs-staff-chip {
  font-weight: 600;
  margin-right: 6px;
}

.home-link {
  font-weight: bold;
  font-size: 20px;
  text-decoration: none;
  color: #ffff;
}

.nav-link {
  text-decoration: none;
  color: #FFF;
  display: flex;
  align-items: center;
  gap: 4px;
  padding-bottom: 2px;
  border-bottom: 3px solid transparent;
}

.nav-icon-link {
  /* color: #ffff; */
  color: #FFF;

}

.nav-icon .router-link-exact-active:not(:last-child),
.nav-icon .router-link-active:not(:last-child),
.nav-icon-link:hover {
  color: #d9dadd;
}

/* [matrah] legacy:
.nav .router-link-exact-active,
.nav .router-link-active,
.nav-link:hover {
  border-bottom: 5px solid #d9dadd;
}
*/
.nav .router-link-exact-active,
.nav .router-link-active,
.nav-link:hover {
  border-bottom: 3px solid #C9A227;
}
</style>
